import { render, staticRenderFns } from "./TableLocalModality.vue?vue&type=template&id=fe8d245a&"
import script from "./TableLocalModality.js?vue&type=script&lang=js&"
export * from "./TableLocalModality.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports